module.exports = __webpack_public_path__ + "img/blood-test.cb5d3f34.png";